module.exports = __webpack_public_path__ + "static/media/PB_G_15.85a9a5f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_15.png
// module id = 228
// module chunks = 0